import { createDomainStore } from '../../storage/create-domain-store';
import { DomainStoreType } from '../../storage/types/domain-store';
import { defaultSessionDomainState } from './state';
/**
 * The single instance of the SessionDomainStore.
 */
export const sessionDomainStore = createDomainStore({
    type: DomainStoreType.BrowserSession,
    defaultState: defaultSessionDomainState,
    name: 'session-domain-store'
});
